import { render, staticRenderFns } from "./AddRoleModal.vue?vue&type=template&id=1db34ee1&scoped=true"
import script from "./AddRoleModal.vue?vue&type=script&lang=js"
export * from "./AddRoleModal.vue?vue&type=script&lang=js"
import style0 from "./AddRoleModal.vue?vue&type=style&index=0&id=1db34ee1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db34ee1",
  null
  
)

export default component.exports